export enum CaseCustomForm {
  CompleteChrono = 'CompleteChrono',
  RecordsReceived = 'RecordsReceived',
  Dictated = 'Dictated',
  BackFromTranscription = 'BackFromTranscription',
  RecordsReviewed = 'RecordsReviewed',
  ReportSent = 'ReportSent',
  Finalized = 'Finalized',
  AssignToEntryUserAndSend = 'AssignToEntryUserAndSend',
  AddCaseDetailItem = 'CreateCaseDetailItem',
  UpdateCasePatient = 'UpdateCasePatient',
  UpdateCaseDetailItem = 'UpdateCaseDetailItem',
  ApplyReceivePayment = 'ApplyReceivePayment',
  SelectDefaultCaseLineItem = 'SelectDefaultCaseLineItem',
}
